import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners'; // Import the spinner
import './common.css';
import { useUser } from '../../contexts/userContext';

interface CityPopupProps {
    onClose: () => void;
    onFetchLocation: () => void;
    onCitySelected: (cityName: string) => void; // Callback to update city in Header
    // setIsLoading: (loading: boolean) => void;
}

const CityPopup: React.FC<CityPopupProps> = ({
    onClose,
    onFetchLocation,
    onCitySelected,
    // setIsLoading,
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [isDetectingLocation, setIsDetectingLocation] = useState(false);
    const [cityDetected, setCityDetected] = useState(false); // New state to track city detection
    const pincodeInputRef = useRef<HTMLInputElement>(null);
    const { setcityName, city_name,fetchCsrfToken, user_id } = useUser();
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    const utmQuery = localStorage.getItem("utm_query_data") || "";

    const handlePincodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (/^\d{0,6}$/.test(value)) {
            setSearchTerm(value);

            // Validate length and update the error message dynamically
            if (value.length < 6) {
                setError('6 digits required');
            } else {
                setError(null);
            }
        }
    };

    const handleDetectLocation = async () => {
        if (!navigator.geolocation) {
            alert('Geolocation is not supported by your browser.');
            return;
        }

        setIsDetectingLocation(true);
        setError(null);
        try {
            // Fetch location details using the callback provided
            await onFetchLocation();

            // Check if city name is available
            const fetchedCity = city_name || 'Detected'; // Replace with actual fetched city
            if (fetchedCity !== 'Detected') {
                onCitySelected(fetchedCity);
                setcityName(fetchedCity);
                setCityDetected(true); // Update state when city is successfully detected
            } else {
                // setError('Unable to detect location. Please try again.');
            }
        } catch (error) {
            // setError('Unable to detect location. Please try again.');
        } finally {
            setIsDetectingLocation(false);
        }
    };

    useEffect(() => {
        if (pincodeInputRef.current) {
            pincodeInputRef.current.focus();
        }
    }, []);
    

    useEffect(() => {
        const fetchCityByPincode = async () => {
            if (searchTerm.length === 6) {
                // setIsLoading(true);
                try {
                    const response = await fetch(`${backendUrl}api/v2/pincode/${searchTerm}`,
                        {  method: 'GET',
                            headers:{
                              // Accept:'aplication/json',
                              "Content-Type": "application/json",
                      
                            },
                            credentials: "include",
                            mode:"cors"            
                      
                          }
                    );
                    const data = await response.json();
                    const ipResponse = await fetch("https://api.ipify.org?format=json");
                    const ipData = await ipResponse.json();
                    const ip_address = ipData.ip; // Extract IP
                    if (!ipResponse.ok) {
                        throw new Error("Failed to fetch IP address");
                    }

                    if (response.ok && data?.data?.city) {

                        onCitySelected(data.data.city);
                        setcityName(data.data.city);
                        setCityDetected(true); // Mark city as detected
                        const userId = user_id
                        const csrfToken = await fetchCsrfToken();
                        const saveInfo = await fetch(`${backendUrl}api/v2/location-save?${utmQuery}`, {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              'X-CSRF-Token': csrfToken,
                            },
                            credentials: "include",
                            body:JSON.stringify({pincode:searchTerm,city:data.data.city,locality:null,user_id:userId,user_agent:navigator.userAgent,ip_address:ip_address}) ,
                          });
                        onClose(); // Close the popup after selection
                    } else {
                        setError('Pincode is Invalid. Please try again.');
                    }
                } catch {
                    setError('Error fetching city. Please try again.');
                } finally {
                    // setIsLoading(false);
                }
            }
        };

        fetchCityByPincode();
    }, [searchTerm]);

    return (
        <div className="popup-overlay">
            <div className="popup-content-city">
                <h1>Select Your City</h1>
                {/* <button
                
                    onClick={handleDetectLocation}
                    className="location-button"
                    disabled={isDetectingLocation || cityDetected}
                > */}
                <button
  onClick={(e) => {
    e.preventDefault();
    handleDetectLocation();
  }}
  className="location-button"
  disabled={isDetectingLocation || cityDetected}
>

                    {isDetectingLocation ? (
                        <ClipLoader color="#3498db" size={20} /> // Displaying the spinner
                    ) : (
                        <>
                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                            <p className="detect-location">Detect My Location</p>
                        </>
                    )}
                </button>
                <p className="permission-location-heading">
                    We will need permission to use your device location.
                </p>
                <div className="or-line">
                    <hr className="line" />
                    <p className="or-title">or</p>
                    <hr className="line" />
                </div>
                <h3>Search Manually</h3>
                <input
                    type="text"
                    placeholder="Pincode"
                    name="pincode"
                    value={searchTerm}
                    onChange={handlePincodeChange}
                    maxLength={6} // Restrict input length to 6 characters
                    ref={pincodeInputRef}
                />
                {error && <p className="error-message-location">{error}</p>} {/* Display error message if any */}
            </div>
        </div>
    );
};

export default CityPopup;
